import React from 'react'
import PropTypes from 'prop-types'

const BottomNav = ({ children }) => (
  <div className="bg-gray-900 text-center flex justify-start items-stretch text-white font-medium px-0 md:px-10 overflow-x-auto">
    {children}
  </div>
)

BottomNav.propTypes = {
  children: PropTypes.node,
}

export default BottomNav
